import styled, { css } from 'styled-components';
import { hexToRgba } from '../../../utils/colors';

export const NotificationWrapper = styled.div`
  padding-bottom: 60px;
`;

export const ConfirmDelete = styled.div`
  max-height: 0;
  overflow: hidden;

  @keyframes expand-confirm-delete {
    0% {
      padding-bottom: 0;
      transform: translate(0, -30px);
      opacity: 0;
    }
    1% {
      padding-bottom: 90px;
    }
    100% {
      padding-bottom: 90px;
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  &.slidein {
    animation: 900ms ease expand-confirm-delete forwards;
    overflow: visible;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  & > button {
    margin-bottom: 0;
  }
`;

export const FiltersWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const Filter = styled.div`
  min-width: 250px;
  max-width: 350px;

  & > div:first-child {
    margin-bottom: 10px;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  &.inline {
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media ${(props) => props.theme.device.mobileL} {
    margin-bottom: 10px;
  }
`;

export const Action = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 120px;
  text-align: center;
  background: ${(props) => props.theme.colors.bgSecondary};
  padding: 10px;
  height: inherit;
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.colors.border};
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 10px 0
      ${(props) => hexToRgba(props.theme.colors.textPrimary, 0.2)};
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100px;
  }
`;

export const Legend = styled.div`
  padding: 20px 24px;
  @media ${(props) => props.theme.device.mobileL} {
    padding: 15px 0;
  }
`;

export const NotificationCard = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isActive'].includes(prop),
})`
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  padding: 24px;
  display: grid;
  grid-template-columns: 30px 1fr 150px;
  gap: 16px;
  transition: ${(props) => props.theme.constants.transitionBase};

  &.not-read {
    background-color: ${(props) => props.theme.colors.notificationNotRead};
  }

  @media ${(props) => props.theme.device.mobileL} {
    position: relative;
    padding: 24px 16px;
    padding-left: 32px;
    ${(props) =>
      props.isActive &&
      css`
        background-color: ${props.theme.colors.selectedNotification} !important;
        box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.3);
      `}
    display:flex;
    flex-wrap: wrap;

    .news {
      margin-left: -16px;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  line-height: inherit;
  & label {
    top: 75%;
  }
  @media ${(props) => props.theme.device.mobileL} {
    display: none;
  }
`;
export const NotificationStatus = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px 0 0 3px;
`;
export const NotificationBody = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    grid-column: 2 / 4;
  }

  .title {
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.link};
    width: fit-content;
  }
  .body {
    font-size: 0.9rem;
    color: ${(props) => props.theme.colors.textSecondary};
  }
`;
export const NotificationIcon = styled.div`
  display: flex;
  align-items: center;
  @media ${(props) => props.theme.device.mobileL} {
    grid-row: 2 / 3;
    grid-column: 3 / 3;
    justify-self: end;
  }
`;

export const NotificationDate = styled.div`
  text-align: right;
  @media ${(props) => props.theme.device.mobileL} {
    margin-left: auto;
  }
`;
